import { Document } from 'mobx-document'
import { Sender } from '~/models'

export default class SenderDocument extends Document<Sender> {

  protected async performFetch() {
    return null
  }
}